/* -------------------------------------------------------------------------- */
/*                            Schema Sensors                                  */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';
export const sensorSchema = new schema.Entity('sensors', {}, { idAttribute: 'sensorId' });
export const sensors = new schema.Array(sensorSchema);
